const reportrecallcolumns = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "detail",
    label: "Report",
  },
  {
    key: "questionRecallId",
    label: "Question Id",
  },
  {
    key: "userName",
    label: "User Name",
  },
  {
    key: "ip",
    label: "Ip",
  },
  {
    key: "reportOptions",
    label: "reportOptions",
  },
  {
    key: "date",
    label: "Date",
  },
  {
    key: "actions",
    label: "Actions",
  },
];

export { reportrecallcolumns };
